import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class BrfInnerFundTransaction extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.rentalObjectId = model.rentalObjectId;
      this.amount = model.amount;
      this.transactionDate = model.transactionDate;
      this.description = model.description;
    } else {
    }
  }

  rentalObjectId: string;
  description: string;
  amount: Money;
  transactionDate: LocalDate;
}
